module.exports = __webpack_public_path__ + "img/shape-4-mobile@2x.175d4ef8.png";